import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { PermissionsService } from '../../../core/services/permissions.service';
import { PERMISSIONS } from '../../../core/constants/permissions.constants';
import { BehaviorSubject } from 'rxjs';
import { ConfigurationService } from '../../../features/configuration/configuration/configuration.service';

type MenuItem = {
  label: string;
  icon: string; // material icon name
  route?: string;
  children?: MenuItem[];
};

@Component({
  selector: 'app-side',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatExpansionModule,
  ],
  templateUrl: './side.component.html',
  styleUrls: ['./side.component.scss'],
})
export class SideComponent {
  public readonly PERMISSIONS = PERMISSIONS;
  public permissions = inject(PermissionsService);
  @Input() isMobile = false;
  @Output() navigate = new EventEmitter<void>();

  logoUrl: string | null = null;

  open = new Set<string>();

  constructor(private configService: ConfigurationService) {
    this.permissions.refresh();
  }

  ngOnInit() {
    this.configService.logo$.subscribe((url) => {
      if (url) this.logoUrl = url;
      else this.logoUrl = 'assets/images/tandhn.jpeg';
    });
  }

  toggle(item: MenuItem) {
    if (!item.children?.length) return;
    const key = item.label;
    this.open.has(key) ? this.open.delete(key) : this.open.add(key);
  }

  isOpen(item: MenuItem) {
    return this.open.has(item.label);
  }

  onNavigate() {
    if (this.isMobile) this.navigate.emit();
  }
}
